var map = {
	"./Algeria": 7991,
	"./Algeria.json": 7991,
	"./Argentina": 7857,
	"./Argentina.json": 7857,
	"./Brazil": 3754,
	"./Brazil.json": 3754,
	"./Burkina Faso": 4023,
	"./Burkina Faso.json": 4023,
	"./Cameroon": 6296,
	"./Cameroon.json": 6296,
	"./Chile": 6945,
	"./Chile.json": 6945,
	"./Colombia": 738,
	"./Colombia.json": 738,
	"./Costa Rica": 9397,
	"./Costa Rica.json": 9397,
	"./El Salvador": 5281,
	"./El Salvador.json": 5281,
	"./Ethiopia": 2639,
	"./Ethiopia.json": 2639,
	"./Ghana": 1131,
	"./Ghana.json": 1131,
	"./Guatemala": 4985,
	"./Guatemala.json": 4985,
	"./Kenya": 2112,
	"./Kenya.json": 2112,
	"./Madagascar": 1196,
	"./Madagascar.json": 1196,
	"./Mexico": 1287,
	"./Mexico.json": 1287,
	"./Mozambique": 7586,
	"./Mozambique.json": 7586,
	"./Nigeria": 2163,
	"./Nigeria.json": 2163,
	"./Paraguay": 3188,
	"./Paraguay.json": 3188,
	"./Senegal": 4091,
	"./Senegal.json": 4091,
	"./South Africa": 7241,
	"./South Africa.json": 7241,
	"./Tanzania": 3526,
	"./Tanzania.json": 3526,
	"./Uganda": 452,
	"./Uganda.json": 452,
	"./Zimbabwe": 3017,
	"./Zimbabwe.json": 3017,
	"./importshapes": 6343,
	"./importshapes.js": 6343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4271;